import { __exports as logger } from "../../../../../../_virtual/logger.js";
import { __require as requireLoglevel } from "../types/loglevel.js";
var hasRequiredLogger;
function requireLogger() {
  if (hasRequiredLogger) return logger;
  hasRequiredLogger = 1;
  Object.defineProperty(logger, "__esModule", { value: true });
  logger.ConsoleLogger = logger.AmplitudeLogger = void 0;
  const loglevel_1 = requireLoglevel();
  class AmplitudeLogger {
    constructor(logLevel, loggerProvider) {
      this.LogLevel = logLevel;
      this.LoggerProvider = loggerProvider;
    }
    verbose(message, ...optionalParams) {
      if (this.shouldLog(loglevel_1.LogLevel.Verbose)) {
        this.LoggerProvider.verbose(message, optionalParams);
      }
    }
    debug(message, ...optionalParams) {
      if (this.shouldLog(loglevel_1.LogLevel.Debug)) {
        this.LoggerProvider.debug(message, optionalParams);
      }
    }
    info(message, ...optionalParams) {
      if (this.shouldLog(loglevel_1.LogLevel.Info)) {
        this.LoggerProvider.info(message, optionalParams);
      }
    }
    warn(message, ...optionalParams) {
      if (this.shouldLog(loglevel_1.LogLevel.Warn)) {
        this.LoggerProvider.warn(message, optionalParams);
      }
    }
    error(message, ...optionalParams) {
      if (this.shouldLog(loglevel_1.LogLevel.Error)) {
        this.LoggerProvider.error(message, optionalParams);
      }
    }
    shouldLog(logLevel) {
      return logLevel <= this.LogLevel;
    }
  }
  logger.AmplitudeLogger = AmplitudeLogger;
  class ConsoleLogger {
    verbose(message, ...optionalParams) {
      console.log(message, optionalParams);
    }
    debug(message, ...optionalParams) {
      console.debug(message, ...optionalParams);
    }
    info(message, ...optionalParams) {
      console.log(message, optionalParams);
    }
    warn(message, ...optionalParams) {
      console.warn(message, ...optionalParams);
    }
    error(message, ...optionalParams) {
      console.error(message, ...optionalParams);
    }
  }
  logger.ConsoleLogger = ConsoleLogger;
  return logger;
}
export {
  requireLogger as __require
};
//# sourceMappingURL=logger.js.map
